<template>
  <div>
    <div
      v-if="period"
      class="period-container"
    >
      <span :id="period.name">{{ period.name }}</span>
      <span class="from-to">
        <span id="from" class="from">{{ formatDate(period.startTs) }}</span>
        <span id="to">{{ period.endTs ? formatDate(period.endTs) : '-' }}</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Period } from 'ctp-geometry';
import Utils from '@/mixins/Utils';

@Component
export default class PeriodListItem extends Mixins(Utils) {
    @Prop()
    periodState!: string;

    @Prop()
    period!: Period;
}
</script>
<style lang="scss" scoped>
@import './styles/period-list-item.scss';
</style>
